import _objectSpread from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { EntityTypes } from '@guryou/core';
import { printTime } from '@guryou/utils';
import { getColorProps, getCustomerIcon, getEventIcon, getNamePreset } from './utils';
import { FlexColumn, FlexRow, SmallText } from '../content';
import { HolidayOffIcon, PauseOffIcon } from '../icons';
const checkEventSize = event => {
  const milliseconds = +new Date(event.endTime) - +new Date(event.startTime);
  const minutes = milliseconds / 60000;
  if (minutes <= 50) {
    return false;
  }
  return true;
};
const EventField = _ref => {
  var _event$capacity, _event$resources2, _event$resources2$, _event$resources3, _event$resources3$;
  let {
    event,
    namePreset,
    t
  } = _ref;
  const colorProps = getColorProps(event);
  const textColorProps = _objectSpread(_objectSpread({}, colorProps), {}, {
    background: 'transparent'
  });
  const size = checkEventSize(event);
  if (event.entityType === 'pause' || event.entityType === 'holiday') {
    var _event$resources;
    return /*#__PURE__*/React.createElement(FlexColumn, _extends({}, colorProps, {
      margin: 0,
      padding: 1,
      height: "100%",
      justifyContent: "start",
      alignItems: "start"
    }), event === null || event === void 0 ? void 0 : (_event$resources = event.resources) === null || _event$resources === void 0 ? void 0 : _event$resources.map(resource => /*#__PURE__*/React.createElement("span", {
      key: resource.id,
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }
    }, resource.name, event.entityType === 'pause' ? /*#__PURE__*/React.createElement(PauseOffIcon, {
      fontSize: "inherit"
    }) : /*#__PURE__*/React.createElement(HolidayOffIcon, {
      fontSize: "inherit"
    }))));
  }
  const content = /*#__PURE__*/React.createElement(FlexColumn, _extends({}, colorProps, {
    margin: 0,
    padding: 1,
    height: "100%",
    justifyContent: "start",
    alignItems: "start"
  }), /*#__PURE__*/React.createElement(FlexRow, {
    justifyContent: "space-between",
    alignItems: "start",
    margin: 0
  }, event.entityType === EntityTypes.service && /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12,
    display: "flex",
    alignItems: "start"
  }), getCustomerIcon(event.user, 'inherit'), " ", "".concat(getNamePreset(namePreset, event)).toUpperCase()), event.entityType !== EntityTypes.service && /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), "".concat(t('GENERAL.capacity')), ": ", (_event$capacity = event.capacity) !== null && _event$capacity !== void 0 ? _event$capacity : 0, "/", event.totalCapacity)), !size && /*#__PURE__*/React.createElement(FlexRow, {
    justifyContent: "flex-start",
    alignItems: "start",
    margin: 0
  }, /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('GENERAL.from'), ": ", printTime(event.startTime), " ", "".concat(t('GENERAL.to'), ": ").concat(printTime(event.endTime))), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12,
    display: "flex",
    alignItems: "center"
  }), event.serviceName, " / ", event.name, " ", getEventIcon(event, 'inherit')), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('PROFILE.resource'), ": ", event === null || event === void 0 ? void 0 : (_event$resources2 = event.resources) === null || _event$resources2 === void 0 ? void 0 : (_event$resources2$ = _event$resources2[0]) === null || _event$resources2$ === void 0 ? void 0 : _event$resources2$.name)), size && /*#__PURE__*/React.createElement(FlexRow, {
    justifyConten: "flex-start",
    alignItems: "start",
    margin: 0
  }, /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('GENERAL.from'), ": ", printTime(event.startTime), " ", "".concat(t('GENERAL.to'), ": ").concat(printTime(event.endTime))), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12,
    display: "flex",
    alignItems: "center"
  }), event.serviceName, " / ", event.name, " ", getEventIcon(event, 'inherit')), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('PROFILE.resource'), ": ", event === null || event === void 0 ? void 0 : (_event$resources3 = event.resources) === null || _event$resources3 === void 0 ? void 0 : (_event$resources3$ = _event$resources3[0]) === null || _event$resources3$ === void 0 ? void 0 : _event$resources3$.name)));
  return content;
};
export default EventField;